$(function() {
    $(".check-nochange").click(function () {
        return false;
    });
});

